module.exports = __webpack_public_path__ + "img/cliente11.4f5a2323.jpg";